import { render, staticRenderFns } from "./PatientPreviousSurgery.vue?vue&type=template&id=c0b352b6&scoped=true&"
import script from "./PatientPreviousSurgery.vue?vue&type=script&lang=js&"
export * from "./PatientPreviousSurgery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b352b6",
  null
  
)

export default component.exports